// author: yusn zhangmyh
// latest: zhangmyh 2017-9-5 8:15 PM
import { Get } from 'common'
/* global $ */

const fileurl = {
  query: '/file/file/query',
  copy: '/file/file/copy'
}

function getFileHeader (str, groupname) {
  let rs = ''
  switch (str) {
    case 'apply':
      rs = 'supplyapply_'
      break
    case 'update':
      rs = 'supplyupdate_'
      break
    case 'doc':
    default:
      rs = 'supplydoc_'
      break
  }
  return rs + ((groupname == '') ? '' : (groupname + '_'))
}

// 复制文件
async function execCopyFile (filepath, groupname, id, tenantid, isAsync) {
  let params = {
    id,
    filepath,
    groupname,
    tenant: tenantid
  }
  let path = fileurl.copy
  if (isAsync) {
    await Get(path, params)
  } else {
    Get(path, params)
  }
  return true
}

async function copyFile (source, target, group, data, conf) {
  let queryUrl = fileurl.query
  const groupname = target + ((group == '') ? data : conf.id)
  const filepath = groupname + ((group == '') ? conf.id : data[conf.idField])
  if (conf.isAsync) {
    let result = await Get(queryUrl, {
      filepath,
      groupname,
      tenant: conf.tenantid
    })
    let rs = 0
    if (result.status == 0 || ($.isArray(result.data) && result.data.length <= 0)) {
      const _groupname = source + ((group == '') ? data : conf.srcId)
      const _filepath = _groupname + ((group == '') ? conf.srcId : data[conf.srcField])
      result = await Get(queryUrl, {
        filepath: _filepath,
        groupname: _groupname,
        tenant: conf.tenantid
      })
      if (result.status == 1 && result.data.length > 0) {
        rs = result.data.length
        for (let i = 0; i < rs; i++) {
          await execCopyFile(filepath, groupname, result.data[i].id, conf.tenantid, true)
        }
      }
    }
    return rs
  } else {
    Get(queryUrl, {
      filepath,
      groupname,
      tenant: data.tenantid
    }).then(function (result, state) {
      if (state == 'success' && (result.status == 0 || (($.isArray(result.data) && result.data.length <= 0)))) {
        const _groupname = source + ((group == '') ? data : conf.srcId)
        const _filepath = _groupname + ((group == '') ? conf.srcId : data[conf.idField])
        Get(queryUrl, {
          filepath: _filepath,
          groupname: _groupname,
          tenant: data.tenantid
        }).then(function (_result, _state) {
          if (_state == 'success' && _result.status == 1 && _result.data.length > 0) {
            _result.data.forEach(function (item) {
              var groupname = target + conf.id
              var filepath = groupname + data[conf.idField]
              execCopyFile(filepath, groupname, item.id, conf.tenantid, false)
            })
          }
        })
      }
    })
    return true
  }
}

async function copyFiles (source, target, group, list, config) {
  config = Object.assign({
    isAsync: true,
    idField: 'id',
  }, config)
  source = getFileHeader(source, group)
  target = getFileHeader(target, group)
  let rs = 0
  if (list && list.length > 0 && config.tenantid && config.id && config.srcId) {
    const n = list.length
    for (let i = 0; i < n; i++) {
      if (config.isAsync) {
        rs += await copyFile(source, target, group, list[i], config)
      } else {
        copyFile(source, target, group, list[i], config)
      }
    }
  }
  return (config.isAsync) ? rs : true
}

async function checkFilesExisted (tenantId, groupname, id) {
  let queryUrl = fileurl.query
  const filepath = groupname + id
  let result = await Get(queryUrl, {
    filepath,
    groupname,
    tenant: tenantId
  })
  if (result.status == 1 || ($.isArray(result.data) && result.data.length > 0)) {
    return true
  }
  return false
}

async function copySupplyFiles (tenantId, srcId, targetId, from, target, data) {
  // 复制主表附件
  const filelist = [
    'busLicenceNum',
    'taxType',
    'accountlicence',
    'creditrating',
    'certificate',
    'authPaperValidate'
  ]
  let rs = await copyFiles(from, target, '', filelist, {
    srcId,
    id: targetId,
    tenantid: tenantId
  })

  // 复制子表附件
  let idField, srcField, tmp
  if (from == 'doc') {
    idField = 'id'
    srcField = 'docId'
  } else {
    idField = 'id'
    srcField = 'sourceId'
  }
  const assolist = [
    'banks',
    'agents',
    'authInfos',
    'categorys',
    'equipments',
    'finances',
    'performances',
    'qualifys'
  ]
  let d = (data.data) ? data.data : data
  for (let i = 0; i < assolist.length; i++) {
    tmp = d[assolist[i]]
    if (assolist[i] == 'finances') {
      rs += await copyFiles(from, target, 'balance', tmp, {
        srcId,
        id: targetId,
        idField,
        srcField,
        tenantid: tenantId
      })
      rs += await copyFiles(from, target, 'cash', tmp, {
        srcId,
        id: targetId,
        idField,
        srcField,
        tenantid: tenantId
      })
      rs += await copyFiles(from, target, 'income', tmp, {
        srcId,
        id: targetId,
        idField,
        srcField,
        tenantid: tenantId
      })
    } else if (assolist[i] == 'qualifys') {
      rs += await copyFiles(from, target, assolist[i], tmp, {
        srcId,
        id: targetId,
        idField: 'qualifyId',
        srcField: 'qualifyId',
        tenantid: tenantId
      })
    } else {
      rs += await copyFiles(from, target, assolist[i], tmp, {
        srcId,
        id: targetId,
        idField,
        srcField,
        tenantid: tenantId
      })
    }
  }

  return rs
}

async function checkSupplyFiles (tenantId, pageType, id, data) {
  const assolist = {
    agents: 'id',
    authInfos: 'id',
    qualifys: 'qualifyId',
    finances: 'id',
    performances: 'id'
    // categorys: 'id',
    // equipments: 'id'
  }
  let i, n, name, groupname, list
  let rs = false
  for (name in assolist) {
    list = data[name]
    if (!list || !$.isArray(list)) {
      continue
    }
    if (name != 'finances') {
      groupname = getFileHeader(pageType, name) + id
    }
    n = list.length
    for (i = 0; i < n; i++) {
      if (name == 'finances') {
        groupname = getFileHeader(pageType, 'balance') + id
        rs = await checkFilesExisted(tenantId, groupname, list[i][assolist[name]])
        if (!rs) {
          return 'balance'
        }
        groupname = getFileHeader(pageType, 'income') + id
        rs = await checkFilesExisted(tenantId, groupname, list[i][assolist[name]])
        if (!rs) {
          return 'income'
        }
        groupname = getFileHeader(pageType, 'cash') + id
        rs = await checkFilesExisted(tenantId, groupname, list[i][assolist[name]])
        if (!rs) {
          return 'cash'
        }
      } else {
        rs = await checkFilesExisted(tenantId, groupname, list[i][assolist[name]])
        if (!rs) {
          return name
        }
      }
    }
  }
  return rs
}

export {
  getFileHeader,
  copyFiles,
  copySupplyFiles,
  checkSupplyFiles
}



// WEBPACK FOOTER //
// ./src/components/fileOperator/index.js